import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
  ResourcesComponent,
  RESOURCES_COMPONENT_TOKEN,
} from '@cgs/machines';
import { Container, EmptyAction, FunctionAction, IntervalAction, TextSceneObject } from '@cgs/wge';

const enum SceneNames {
  TotalText = 'fs_amount',
}

export const CORSICA_FREE_SPINS_COUNT_COMPONENT_TOKEN = Symbol('CorsicaFreeSpinsCountComponent');

export class CorsicaFreeSpinsCountComponent {
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly freeSpinsCount: TextSceneObject[];

  constructor(container: Container) {
    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this.freeSpinsCount = container
      .resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN)
      .slot.findAllById(SceneNames.TotalText)!;

    this.gameStateMachine.accelerate.addLazyAnimationToBegin(() => this.decreaseCount());
    this.gameStateMachine.stop.appendLazyAnimation(() => this.updateCount());
    this.gameStateMachine.freeSpinsRecovery.appendLazyAnimation(() => this.updateCount());
  }

  private decreaseCount(): IntervalAction {
    if (!this.gameStateMachine.curResponse.isFreeSpins) {
      return new EmptyAction();
    }
    if (!this.gameStateMachine.curResponse.freeSpinsInfo?.currentFreeSpinsGroup?.count) {
      return new EmptyAction();
    }

    const count = this.gameStateMachine.curResponse.freeSpinsInfo.currentFreeSpinsGroup.count - 1;

    return new FunctionAction(() => {
      this.freeSpinsCount.forEach((text) => (text.text = `${count}`));
    });
  }

  private updateCount(): IntervalAction {
    if (!this.gameStateMachine.curResponse.isFreeSpins) {
      this.freeSpinsCount.forEach((text) => (text.text = '0'));
      return new EmptyAction();
    }

    return new FunctionAction(() => {
      this.freeSpinsCount.forEach(
        (text) =>
          (text.text = `${this.gameStateMachine.curResponse.freeSpinsInfo?.currentFreeSpinsGroup?.count}`)
      );
    });
  }
}
